/*=========================================================================================
  File Name: moduleStaffMutations.js
  Description: Staff Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Speed HRM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  
};
